@if (form.controls.createSlutopgoerelse.value && slutopgoerelseDraft) {
  <div class="form-row no-margin-top margin--bottom-l">
    <div class="align-center">
      <div class="slutopgorelse-draft-header">
        <h3>Forventet slutopgørelse</h3>
        @if (fetchingSlutopgoerelseDraft) {
          <mat-spinner [diameter]="20"></mat-spinner>
        }
      </div>
      @if (slutopgoerelseDraft.lines.length>0) {
        <div class="detail-rows">
          @for (line of slutopgoerelseDraft.lines; track line; let i = $index) {
            <div class="detail-row">
              <div class="detail-row__lbl">{{line.tekst}}</div>
              <div class="detail-row__val">{{ getPriceStringForLine(line) | dkCurrency }}</div>
            </div>
          }
          <div class="detail-row bold">
            <div class="detail-row__lbl">Total</div>
            <div class="detail-row__val">{{ getPrice(slutopgoerelseDraft.sum) | dkCurrency }}</div>
          </div>
        </div>
      }
    </div>
  </div>
  @if (slutopgoerelseDraft.hasPendingAfregning) {
    <div class="orange icon-with-text margin--bottom-m">
      <mat-icon svgIcon="obs-solid"></mat-icon>
      <span>Vær opmærksom på igangværende opkrævninger, som endnu ikke er opkrævet via G4</span>
    </div>
  }
}
